export default "__VITE_ASSET__DA03uGib__"